/** Intervalos e timeouts do Atendabot (ms). */

/** Poll dos cards / status do bot no dashboard. */
export const DASHBOARD_POLL_INTERVAL_MS = 4_000;

/** Expiração do QR Code do WhatsApp (Z-API). */
export const QR_CODE_EXPIRATION_MS = 55_000;

/** Poll do status Z-API enquanto o QR está aberto. */
export const ZAPI_STATUS_POLL_INTERVAL_MS = 5_000;

/** Poll de mensagens da conversa selecionada. */
export const CONVERSATION_MESSAGES_POLL_MS = 3_000;

/** Poll da lista de conversas. */
export const CONVERSATIONS_LIST_POLL_MS = 5_000;

/** Atualização do timer de gravação de áudio. */
export const RECORDING_TICK_MS = 250;

/** Poll da lista de pedidos (aba visível). */
export const ORDERS_REFRESH_INTERVAL_MS = 5_000;
